import React, { useState } from "react";
import { FaArrowRightLong, FaRegEye, FaRegEyeSlash } from "react-icons/fa6";
import { emailicon, messageicon } from "../../../assets/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { loginValidation } from "../../../validations/auth";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { useMutation } from "@tanstack/react-query";
import useUser from "../../../hooks/useUser";
import ButtonLoader from "../../../component/buttonLoader";


const Email = () => {
  const { setUser } = useUser();
  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { login } = AuthService();
  const [changePassword, setChangePassword] = useState(true);
  const changeIcon = !changePassword;
  const location = useLocation();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(loginValidation),
    defaultValues: {
      email: "",
      password: ""
    }
  });
  // ---------redirect-page----------------
  function handleLoginSuccess() {
    const redirectPath = location.state?.from === "/healthplan"
      ? "/healthplan"
      : "/";
    navigate(redirectPath);
  }

  const sendOtpMutation = useMutation({
    mutationFn: data => login({ ...data, deviceType: "web", deviceToken: "dummy" }),
    onSuccess: (data) => {
      localStorage.setItem("hollypills_token", data?.data?.token);
      setUser(data?.data?.user);
      snackbar((data?.message || ""), "info");
      handleLoginSuccess();
    },
    onError: (err) => {
      snackbar((err.data.message || ""));
    }
  });


  return (
    <>
      <form onSubmit={handleSubmit(sendOtpMutation.mutate)}>
        <div className="form_field icon_set">
          <label className="label" htmlFor="">
            Email Address
          </label>
          <input
            type="mail"
            className="input form-control"
            placeholder="Enter Your Email"
            {...register("email")}
          />
          <img src={messageicon} alt="icon" />
          {errors.email?.message && <span className="error">{errors.email?.message}</span>}
        </div>
        <div className="form_field icon_set">
          <label className="label" htmlFor="">
            Password
          </label>
          <input
            // type="number"
            type={changePassword ? "password" : "text"}
            className="input form-control"
            placeholder="Enter Your Password..."
            {...register("password")}
          />
          <span
            onClick={() => {
              setChangePassword(changeIcon);
            }}
          >
            {changeIcon ? <FaRegEyeSlash /> : <FaRegEye />}
          </span>
          <img src={emailicon} alt="icon" />
          {errors.password?.message && <span className="error">{errors.password?.message}</span>}
        </div>
        <div className="btn_wrap_login" >
          <ButtonLoader
            text={<>Log In<FaArrowRightLong /></>}
            className="login"
            isLoading={sendOtpMutation.isPending}
          />
        </div>
      </form>
      <div className="account_signup">
        <p>
          Already have an account ? <Link to={"/signup"}> Sign Up. </Link>
        </p>
        <p>
          <Link to={"/forgot"}> Forgot your password? </Link>
        </p>
      </div>
    </>
  );
};

export default Email;
